import axios from 'axios';

import { api } from '../../boot/axios';

export interface UserData {
  user_id: string;
  first_name: string;
  last_name: string;
  phone_number: string;
  reason_for_call: string;
  principal: string;
  //date_added: Date;
  job_id: string;
  //area_code: string;
  address: string;
}

// Payload type for the external POST request
export interface CallRegistryPayload {
  userId: string;
  firstName: string;
  lastName: string;
  answer: string;
  callSequence: string;
  status: string;
  phone: string;
  jobId: string;
  principal: string;
  homeOwner: boolean;
}

export interface CallApiResponse {
  completed: boolean;
  queue_status: string | null;
  error_message: string | null;
  answered_by: string | null;
  status: string | null;
  concatenated_transcript: string;
  transcripts: Array<{
    id: number;
    created_at: string;
    text: string;
    user: string;
    c_id: string;
    status: string | null;
    transcript_id: string | null;
  }>;
  is_terminal: boolean;
  status_group: 'success' | 'failure' | 'unknown' | 'in_progress';
  failure_reason: string | null;
  status_detail: string | null;
  queue_status_detail: string | null;
}

/**
 * Makes a POST request to the external Lambda call register.
 * @param payload The payload to send in the POST request.
 * @returns The response data or null if an error occurs.
 */
export const postToCallRegistryLambda = async (payload: CallRegistryPayload) => {
  try {
    const response = await axios.post(
      'https://nxh25012hf.execute-api.us-east-2.amazonaws.com/dev',
      payload
    );
    console.log('response from call registry api');
    console.log(response.data);

    return response.data;
  } catch (error) {
    console.error('Error posting to call registry Lambda:', error);
    return null;
  }
};

export const startConverstion = async (user: UserData) => {
  try {
    //const response = await api.post<{ call_id: string; status: 'string' }>('/call-register', user);
    const response = await api.post('/call', user);
   
    console.log('response from call api');
    console.log(response.data);
   
    return response.data;

  } catch (error) {
    console.error(error);
    return null;
  }
};

export const loadConversationLogs = async (call_id: string) => {
  try {
    const response = await api.get<CallApiResponse>(`/call/${call_id}`);
    return response.data;
  } catch (error) {
    console.error(error);
    return null;
  }
};

export const getCallReport = async (startDate?: string, endDate?: string) => {
  try {
    const params = new URLSearchParams();
    if (startDate) params.append('startDate', startDate);
    if (endDate) params.append('endDate', endDate);
    const query = params.toString() ? `?${params.toString()}` : '';
    // Try to get as blob first
    const response = await api.get(`/call-report${query}`, { responseType: 'blob' });
    // Try to detect if it's a JSON response (base64) or a real file
    const contentType = response.headers['content-type'] || response.headers['Content-Type'];
    if (contentType && contentType.includes('application/json')) {
      // Read the blob as text, then parse JSON and decode base64
      const text = await response.data.text();
      const data = JSON.parse(text);
      const base64 = data && data.body;
      if (!base64) {
        console.error('No file data received', data);
        return null;
      }
      const binary = window.atob(base64);
      const len = binary.length;
      const bytes = new Uint8Array(len);
      for (let i = 0; i < len; i++) {
        bytes[i] = binary.charCodeAt(i);
      }
      return new Blob([bytes], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
    } else {
      // It's already a Blob (Excel file)
      return response.data;
    }
  } catch (error) {
    console.error('Error downloading report:', error);
    return null;
  }
};
